import React from 'react';
import { HOW_IT_WORKS } from '../mock';
import { Calendar, Salad, Truck } from 'lucide-react';

const ICONS = [Calendar, Salad, Truck];

export default function HowItWorks() {
  return (
    <section id="how" className="bg-[#1B4631] text-[#F6F2E8] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-28">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-[0.22em] text-[#E8C56B] font-semibold">How it works</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-3 leading-[1.05]">
            Office &amp; corporate catering, <em className="text-[#E8C56B] not-italic">without the headache.</em>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8">
          {HOW_IT_WORKS.map((s, idx) => {
            const Icon = ICONS[idx];
            return (
              <div key={s.step} className="bg-[#245A40] rounded-3xl p-7 lg:p-8 border border-white/5 hover:border-[#E8C56B]/40 transition-colors">
                <div className="flex items-center justify-between">
                  <div className="w-12 h-12 rounded-2xl bg-[#F6F2E8] grid place-items-center">
                    <Icon className="w-5 h-5 text-[#1B4631]" />
                  </div>
                  <div className="font-display text-5xl text-[#E8C56B]/70">{s.step}</div>
                </div>
                <h3 className="font-display text-2xl mt-6">{s.title}</h3>
                <p className="mt-3 text-[#D9D2C2] text-[15px] leading-relaxed">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
